<div class="chat-container">
  <div class="chat-layout">
    <!-- Left Sidebar: Contacts & Requests -->
    <div class="chat-sidebar" [class.hidden]="selectedContact && isMobile">
      <!-- Sidebar Header -->
      <div class="sidebar-header">
        <div class="header-info">
          <div class="avatar user-avatar">
            @if (currentUserAvatar) {
            <img [src]="currentUserAvatar" [alt]="(currentUserName || 'User') + ' profile photo'" [title]="currentUserName || 'User'" loading="lazy" />
            } @else {
            <i class="fas fa-user-circle"></i>
            }
          </div>
          <div class="header-text">
            <h3 class="chat-title">Messages</h3>
            <p class="chat-subtitle">{{ currentUserName }}</p>
          </div>
        </div>
        <div class="header-actions">
          <button class="create-group-button" (click)="showCreateGroupModal = true" title="Create group chat">
            <i class="fas fa-users"></i>
          </button>
          <button class="search-button" (click)="toggleUserSearch()" title="Search users">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>

      <!-- Tabs: Contacts / Requests -->
      <div class="sidebar-tabs">
        <button class="tab-button" [class.active]="!showRequests" (click)="showRequests = false">
          <span>Contacts</span>
          @if (contacts.length > 0) {
          <span class="badge">{{ contacts.length }}</span>
          }
        </button>
        <button class="tab-button" [class.active]="showRequests" (click)="showRequests = true">
          <span>Requests</span>
          @if (getAllConnectionRequests().length > 0) {
          <span class="badge">{{ getAllConnectionRequests().length }}</span>
          }
        </button>
      </div>

      <!-- Contacts List -->
      @if (!showRequests) {
      <div class="contacts-list">
        @if (contacts.length > 0) {
        @for (contact of contacts; track contact.userId) {
        <div class="contact-item" [class.active]="selectedContact?.userId === contact.userId" (click)="selectContact(contact)">
          <div class="contact-avatar">
            @if (contact.avatar) {
            <img [src]="contact.avatar" [alt]="(contact.name || 'Contact') + ' avatar'" title="{{contact.name || 'Contact'}}" loading="lazy" />
            } @else {
            <div class="avatar-placeholder">
              <span>{{ contact.name.charAt(0).toUpperCase() }}</span>
            </div>
            }
          </div>
          <div class="contact-info">
            <p class="contact-name">{{ contact.name }}</p>
            <p class="contact-email">{{ contact.email }}</p>
          </div>
          <div class="contact-actions">
            @if (contact.unreadCount && contact.unreadCount > 0) {
            <span class="unread-badge">{{ contact.unreadCount }}</span>
            }
            <div class="contact-menu-wrapper" (click)="$event.stopPropagation()">
              <button class="contact-menu-button" (click)="toggleContactMenu($event, contact)" title="More options">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              @if (openContactMenu === contact.userId) {
              <div class="contact-menu-dropdown" (click)="$event.stopPropagation()">
                @if (contact.isGroup) {
                <button class="menu-item" (click)="openEditGroupModal(contact)">
                  <i class="fas fa-pen"></i>
                  <span>Edit Group</span>
                </button>
                } @else {
                <button class="menu-item" (click)="unfriendContact(contact, 'cancelled')">
                  <i class="fas fa-user-minus"></i>
                  <span>Unfriend</span>
                </button>
                <button class="menu-item" (click)="unfriendContact(contact, 'blocked')">
                  <i class="fas fa-user-slash"></i>
                  <span>Block User</span>
                </button>
                }
                <button class="menu-item" (click)="clearContactMessages(contact)">
                  <i class="fas fa-trash-alt"></i>
                  <span>Clear Messages</span>
                </button>
                <button class="menu-item" (click)="exportContactMessages(contact)">
                  <i class="fas fa-download"></i>
                  <span>Export Messages</span>
                </button>
                <button class="menu-item" (click)="handleAddEventOption(contact)">
                  <i class="fas fa-calendar-plus"></i>
                  <span>Add Event</span>
                </button>
              </div>
              }
            </div>
          </div>
        </div>
        }
        } @else {
        <div class="empty-state">
          <i class="fas fa-envelope"></i>
          <p>No contacts yet</p>
          <p class="hint">Accept connection requests to start chatting</p>
        </div>
        }
      </div>
      }

      <!-- Connection Requests List -->
      @if (showRequests) {
      <div class="requests-list">
        @if (getAllConnectionRequests().length > 0) {
        @for (request of getAllConnectionRequests(); track request._id) {
        <div class="request-item" [class.sent-request]="isSentRequest(request)">
          <div class="request-avatar">
            @if (isSentRequest(request)) {
            @if (request.toUserAvatar) {
            <img [src]="request.toUserAvatar" [alt]="(request.toUserName || 'User') + ' avatar'" [title]="request.toUserName || 'User'" loading="lazy" />
            } @else {
            <div class="avatar-placeholder">
              <span>{{ (request.toUserName || 'U').charAt(0).toUpperCase() }}</span>
            </div>
            }
            } @else {
            @if (request.fromUserAvatar) {
            <img [src]="request.fromUserAvatar" [alt]="(request.fromUserName || 'User') + ' avatar'" [title]="request.fromUserName || 'User'" loading="lazy" />
            } @else {
            <div class="avatar-placeholder">
              <span>{{ (request.fromUserName || 'U').charAt(0).toUpperCase() }}</span>
            </div>
            }
            }
          </div>
          <div class="request-info">
            @if (isSentRequest(request)) {
            <p class="request-name">{{ request.toUserName }}</p>
            <p class="request-status">Pending</p>
            } @else {
            <p class="request-name">{{ request.fromUserName }}</p>
            @if (request.message) {
            <p class="request-message">{{ request.message }}</p>
            }
            }
          </div>
          <div class="request-actions">
            @if (isSentRequest(request)) {
            <button class="cancel-btn" (click)="cancelConnectionRequest(request)" title="Cancel request">
              <i class="fas fa-times"></i>
              <span>Cancel</span>
            </button>
            } @else {
            <button class="accept-btn" (click)="respondToRequest(request, 'accepted')" title="Accept">
              <i class="fas fa-check"></i>
            </button>
            <button class="reject-btn" (click)="respondToRequest(request, 'rejected')" title="Reject">
              <i class="fas fa-times"></i>
            </button>
            <button class="block-btn" (click)="blockRequest(request)" title="Block/Deny">
              <i class="fas fa-user-slash"></i>
            </button>
            }
          </div>
        </div>
        }
        } @else {
        <div class="empty-state">
          <i class="fas fa-envelope"></i>
          <p>No connection requests</p>
        </div>
        }
      </div>
      }
    </div>

    <!-- Main Chat Area -->
    <div class="chat-main" [class.visible]="selectedContact && isMobile">
      @if (selectedContact) {
      <!-- Chat Header -->
      <div class="chat-header">
        <div class="header-content">
          <div class="header-info">
            <div class="avatar contact-avatar">
              @if (selectedContact.avatar) {
              <img [src]="selectedContact.avatar" [alt]="(selectedContact.name || 'Contact') + ' avatar'" [title]="selectedContact.name || 'Contact'" loading="lazy" />
              } @else {
              <div class="avatar-placeholder">
                <span>{{ selectedContact.name.charAt(0).toUpperCase() }}</span>
              </div>
              }
            </div>
            <div class="header-text">
              <h3 class="chat-title">{{ selectedContact.name }}</h3>
              <p class="chat-subtitle">{{ selectedContact.email }}</p>
            </div>
          </div>
          <div class="header-actions">
            @if (isMobile) {
            <button class="back-button" (click)="goBackToContacts()" title="Back to contacts">
              <i class="fas fa-arrow-left"></i>
            </button>
            }
            @if (!isMobile) {
            <button class="clear-button" (click)="clearChat()" title="Close chat">
              <i class="fas fa-times"></i>
            </button>
            }
          </div>
        </div>
      </div>

      <!-- Messages Container -->
      <div class="messages-container" #messagesContainer (contextmenu)="onMessagesContainerContextMenu($event)">
        <div class="messages-list">
          @for (group of getGroupedMessages(); track group.date) {
          <div class="date-group">
            <div class="date-header">
              <span class="date-header-text">{{ formatDateHeader(group.date) }}</span>
            </div>
            @for (message of group.messages; track message._id || message.id) {
            <div class="message-wrapper" [class.user-message]="message.sender === 'user'" [class.other-message]="message.sender !== 'user'"
                 [class.self-destructing]="isSelfDestructingMessage(message._id || message.id)" [data-message-id]="message._id || message.id">
              <div class="message-bubble" [class.typing]="message.isTyping" [class.self-destruct]="isSelfDestructingMessage(message._id || message.id)">
                @if (message.isTyping) {
                <div class="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                }
                @if (!message.isTyping) {
                <div class="message-content">
                  @if (isEditingMessage(message._id || message.id)) {
                  <div class="edit-message-container">
                    <textarea #editInput class="edit-message-input" [(ngModel)]="editingMessageText" (keydown.escape)="cancelEditingMessage()" (keydown)="onEditKeyPress($event)" rows="2"></textarea>
                    <div class="edit-message-actions">
                      <button class="delete-edit-button" (click)="deleteMessage(message)" title="Delete message">
                        <i class="fas fa-trash-alt"></i>
                        <span>Delete</span>
                      </button>
                      <div class="edit-actions-spacer"></div>
                      <button class="cancel-edit-button" (click)="cancelEditingMessage()" title="Cancel (Esc)">
                        <i class="fas fa-times"></i>
                        <span>Cancel</span>
                      </button>
                      <button class="save-edit-button" (click)="saveEditedMessage()" [disabled]="!editingMessageText.trim()" title="Save (Enter)">
                        <i class="fas fa-check"></i>
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                  } @else {
                  @if (message.attachment) {
                  <div class="file-attachment">
                    <div class="file-attachment-content" (click)="downloadFile(message.attachment)">
                      <i class="fas file-attachment-icon" [ngClass]="getFileIcon(message.attachment.mimeType) === 'image' ? 'fa-image' : (getFileIcon(message.attachment.mimeType) === 'pdf' ? 'fa-file-pdf' : 'fa-file')"></i>
                      <div class="file-attachment-info">
                        <span class="file-attachment-name">{{ message.attachment.fileName }}</span>
                        <span class="file-attachment-size">{{ getFileSize(message.attachment.fileSize) }}</span>
                      </div>
                      <i class="fas fa-download download-icon"></i>
                    </div>
                    @if (message.attachment.mimeType.startsWith('image/')) {
                    <div class="image-preview">
                      <img [src]="'data:' + message.attachment.mimeType + ';base64,' + message.attachment.fileData" [alt]="message.attachment.fileName || 'Attachment'" title="message.attachment.fileName || 'Attachment'" loading="lazy" />
                    </div>
                    }
                  </div>
                  }
                  @if (message.poll) {
                  <div class="poll-container" [class.poll-closed]="isPollExpired(message)">
                    <div class="poll-header">
                      <i class="fas fa-chart-bar poll-icon"></i>
                      <h4 class="poll-question">{{ message.poll.question }}</h4>
                    </div>
                    <div class="poll-options">
                      @for (option of message.poll.options; track option.id) {
                      <div class="poll-option" [class.selected]="hasVotedForOption(message.poll, option.id)" (click)="!isPollExpired(message) && voteOnPoll(message, option.id)">
                        <div class="poll-option-content">
                          <div class="poll-option-checkbox">
                            @if (message.poll.allowMultiple) {
                            <div class="checkbox-multiple" [class.checked]="hasVotedForOption(message.poll, option.id)">
                              @if (hasVotedForOption(message.poll, option.id)) {
                              <i class="fas fa-check"></i>
                              }
                            </div>
                            } @else {
                            <div class="checkbox-single" [class.checked]="hasVotedForOption(message.poll, option.id)">
                              @if (hasVotedForOption(message.poll, option.id)) {
                              <div class="radio-dot"></div>
                              }
                            </div>
                            }
                          </div>
                          <span class="poll-option-text">{{ option.text }}</span>
                        </div>
                        @if (message.poll.totalVotes > 0) {
                        <div class="poll-option-stats">
                          <div class="poll-option-bar" [style.width.%]="(option.votes / message.poll.totalVotes) * 100"></div>
                          <span class="poll-option-percentage">{{ getPollPercentage(option.votes, message.poll.totalVotes) }}%</span>
                          <span class="poll-option-votes">({{ option.votes }})</span>
                        </div>
                        }
                      </div>
                      }
                    </div>
                    <div class="poll-footer">
                      <span class="poll-total-votes">{{ message.poll.totalVotes }} {{ message.poll.totalVotes === 1 ? 'vote' : 'votes' }}</span>
                      @if (message.poll.expiresAt) {
                      <span class="poll-expires">{{ isPollExpired(message) ? 'Closed' : 'Expires ' + formatPollExpiry(message.poll.expiresAt) }}</span>
                      }
                    </div>
                  </div>
                  }
                  @if (message.sharedContact) {
                  <div class="shared-contact-container">
                    <div class="shared-contact-header">
                      <i class="fas fa-address-card shared-contact-icon"></i>
                      <span class="shared-contact-label">Shared Contact</span>
                    </div>
                    <div class="shared-contact-content">
                      <div class="shared-contact-avatar">
                        @if (message.sharedContact.avatar) {
                        <img [src]="message.sharedContact.avatar" [alt]="(message.sharedContact.name || 'Contact') + ' avatar'" [title]="message.sharedContact.name || 'Contact'" loading="lazy" />
                        } @else {
                        <div class="avatar-placeholder">
                          <span>{{ message.sharedContact.name.charAt(0).toUpperCase() }}</span>
                        </div>
                        }
                      </div>
                      <div class="shared-contact-info">
                        <p class="shared-contact-name">{{ message.sharedContact.name }}</p>
                        <p class="shared-contact-email">{{ message.sharedContact.email }}</p>
                      </div>
                    </div>
                  </div>
                  }
                  @if (message.text && !message.poll && !message.sharedContact) {
                  <p class="message-text">{{ message.text }}</p>
                  }
                  <div class="message-footer">
                    @if (selectedContact.isGroup && message.sender !== 'user' && message.userName) {
                    <span class="message-sender-name">{{ message.userName }}</span>
                    }
                    <span class="message-time">{{ formatTime(message.timestamp) }}</span>
                    @if (isSelfDestructingMessage(message._id || message.id)) {
                    @if (getSelfDestructRemainingTime(message) !== null) {
                    <span class="self-destruct-indicator" [title]="'This message will be deleted in ' + getSelfDestructRemainingTime(message) + 's'">
                      <i class="fas fa-clock"></i>
                      <span>{{ getSelfDestructRemainingTime(message) }}s</span>
                    </span>
                    }
                    }
                    @if (message.edited) {
                    <span class="edited-indicator" title="Edited">edited</span>
                    }
                    @if (message.sender === 'user') {
                    <span class="read-status" [class.read]="message.read" [title]="message.read ? 'Read' : 'Sent'">
                      <i class="fas fa-check checkmark-single"></i>
                      @if (message.read) {
                      <i class="fas fa-check-double checkmark-double"></i>
                      }
                    </span>
                    }
                  </div>
                  @if (canEditMessage(message)) {
                  <button class="edit-message-button" (click)="startEditingMessage(message)" title="Edit message">
                    <i class="fas fa-pen"></i>
                  </button>
                  }
                  }
                </div>
                }
              </div>
            </div>
            }
          </div>
          }
          @if (isOtherUserTyping) {
          <div class="message-wrapper other-message">
            <div class="message-bubble typing">
              <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
          }
        </div>

        <!-- Background Context Menu -->
        @if (showBackgroundMenu) {
        <div class="background-context-menu" [style.top.px]="backgroundMenuPosition.top" [style.left.px]="backgroundMenuPosition.left" (click)="$event.stopPropagation()">
          <div class="context-menu-header">
            <span>Change Background</span>
          </div>
          <div class="background-options">
            @for (option of backgroundOptions; track option.id) {
            <button class="background-option" [class.selected]="selectedBackground === option.id" (click)="selectBackground(option.id)" [title]="option.name">
              <span class="background-preview" [style.background-color]="option.preview"></span>
              <span class="background-name">{{ option.name }}</span>
              @if (selectedBackground === option.id) {
              <i class="fas fa-check check-icon"></i>
              }
            </button>
            }
          </div>
        </div>
        }
      </div>

      <!-- Input Area -->
      <div class="input-container">
        @if (selectedFile) {
        <div class="file-preview">
          <div class="file-preview-info">
            <i class="fas fa-file file-icon"></i>
            <div class="file-info">
              <span class="file-name">{{ selectedFile.name }}</span>
              <span class="file-size">{{ getFileSize(selectedFile.size) }}</span>
            </div>
          </div>
          <button class="remove-file-button" (click)="removeSelectedFile()" title="Remove file">
            <i class="fas fa-times"></i>
          </button>
        </div>
        }
        <!-- Self-Destruct Toggle -->
        <div class="self-destruct-toggle">
          <label class="self-destruct-label">
            <input type="checkbox" [(ngModel)]="enableSelfDestruct" class="self-destruct-checkbox" />
            <span class="self-destruct-text">
              <i class="fas fa-clock self-destruct-icon"></i>
              <span>Delete after 5 min</span>
            </span>
          </label>
        </div>
        <div class="input-wrapper">
          <input placeholder="Attach file" type="file" #fileInput class="file-input" (change)="onFileSelected($event)" accept="*/*" class="d-none"/>
          <input placeholder="Attach photo or video" type="file" #photoVideoInput class="file-input" (change)="onPhotoVideoSelected($event)" accept="image/*,video/*" class="d-none"/>
          <div class="input-buttons">
            <div class="attach-button-wrapper">
              <button class="attach-button" (click)="toggleAttachMenu()" [disabled]="isLoading" title="Attach">
                <i class="fas fa-paperclip"></i>
              </button>
              @if (showAttachMenu) {
              <div class="attach-menu">
                <button class="attach-menu-item" (click)="selectAttachOption('file')">
                  <i class="fas fa-file"></i>
                  <span>File</span>
                </button>
                <button class="attach-menu-item" (click)="selectAttachOption('photo-video')">
                  <i class="fas fa-image"></i>
                  <span>Photo & Video</span>
                </button>
                <button class="attach-menu-item" (click)="selectAttachOption('contact')">
                  <i class="fas fa-address-card"></i>
                  <span>Contact</span>
                </button>
                <button class="attach-menu-item" (click)="selectAttachOption('poll')">
                  <i class="fas fa-chart-bar"></i>
                  <span>Poll</span>
                </button>
                <button class="attach-menu-item" (click)="selectAttachOption('event')">
                  <i class="fas fa-calendar-plus"></i>
                  <span>Event</span>
                </button>
              </div>
              }
            </div>
          </div>
          <div class="input-with-autocomplete">
            <textarea #messageInput class="message-input" [(ngModel)]="messageText" (keydown)="onKeyPress($event)" (input)="onInputChange()" (click)="checkAutocomplete()" (blur)="onInputBlur()"
                      placeholder="Type your message..." rows="1" [disabled]="isLoading"></textarea>
            @if (showAutocomplete && autocompleteSuggestions.length > 0) {
            <div class="autocomplete-dropdown" [style.top.px]="autocompletePosition.top" [style.left.px]="autocompletePosition.left">
              @for (suggestion of autocompleteSuggestions; track suggestion.value) {
              <div class="autocomplete-item" [class.selected]="$index === selectedSuggestionIndex" (click)="selectSuggestion(suggestion)" (mouseenter)="selectedSuggestionIndex = $index">
                @if (suggestion.type === 'mention') {
                <div class="autocomplete-mention">
                  @if (suggestion.avatar) {
                  <img [src]="suggestion.avatar" [alt]="(suggestion.display || suggestion.value || 'User') + ' avatar'" [title]="suggestion.display || suggestion.value || 'User'" class="autocomplete-avatar" loading="lazy" />
                  } @else {
                  <div class="autocomplete-avatar-placeholder">{{ suggestion.display.charAt(0).toUpperCase() }}</div>
                  }
                  <div class="autocomplete-info">
                    <span class="autocomplete-name">{{ suggestion.display }}</span>
                    @if (suggestion.email && suggestion.email !== suggestion.display) {
                    <span class="autocomplete-email">{{ suggestion.email }}</span>
                    }
                  </div>
                </div>
                } @else if (suggestion.type === 'emoji') {
                <div class="autocomplete-emoji">
                  <span class="autocomplete-emoji-icon">{{ suggestion.emoji }}</span>
                  <span class="autocomplete-emoji-name">{{ suggestion.name }}</span>
                </div>
                } @else {
                <div class="autocomplete-phrase">
                  <span>{{ suggestion.display }}</span>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          <div class="emoji-picker-wrapper">
            <button class="emoji-button" (click)="toggleEmojiPicker()" [disabled]="isLoading" title="Add emoji" mdb-tooltip="Add emoji">
              <i class="fas fa-smile"></i>
            </button>
            @if (showEmojiPicker) {
            <div class="emoji-picker">
              <div class="emoji-picker-header">
                <span>Quick Emojis</span>
              </div>
              <div class="emoji-grid">
                @for (emojiItem of quickEmojis; track emojiItem.emoji) {
                <button class="emoji-item" (click)="insertEmoji(emojiItem.emoji)" [title]="emojiItem.name">
                  <span class="emoji-icon">{{ emojiItem.emoji }}</span>
                </button>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      } @else {
      <!-- Empty Chat State -->
      <div class="empty-chat">
        <i class="fas fa-comments"></i>
        <h3>Select a contact to start chatting</h3>
        <p>Choose someone from your contacts or accept a connection request</p>
      </div>
      }
    </div>
  </div>


  <!-- User Search Panel (Overlay) -->
  @if (showUserSearch) {
  <div class="search-panel-overlay" (click)="toggleUserSearch()">
    <div class="search-panel" (click)="$event.stopPropagation()">
      <div class="search-panel-header">
        <h3>Search Users</h3>
        <button class="close-button" (click)="toggleUserSearch()" title="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="search-input-wrapper">
        <div class="search-input-container">
          <i class="fas fa-search search-icon"></i>
          <input type="text" #searchInput class="search-input" [(ngModel)]="searchQuery" (input)="onSearchInput()" (keydown.escape)="toggleUserSearch()" (blur)="onSearchBlur()"
                 (focus)="onSearchFocus()" placeholder="Search by name or email..." autocomplete="off" />
          @if (isSearching) {
          <div class="search-spinner"></div>
          }
          @if (searchQuery && !isSearching) {
          <button class="clear-search-button" (click)="clearSearch()" title="Clear search">
            <i class="fas fa-times"></i>
          </button>
          }
        </div>
      </div>

      <!-- Search Results -->
      <div class="search-content">
        @if (searchResults.length > 0) {
        <div class="search-results">
          @for (user of searchResults; track user.userId || user.email) {
          <div class="user-result-item">
            <div class="user-info">
              <div class="user-avatar-small">
                @if (user.avatar) {
                <img [src]="user.avatar" [alt]="(user.name || 'User') + ' avatar'" [title]="user.name || 'User'" loading="lazy" />
                } @else {
                <div class="avatar-placeholder">
                  <span>{{ (user.name || user.email || 'U').charAt(0).toUpperCase() }}</span>
                </div>
                }
              </div>
              <div class="user-details">
                <p class="user-name">{{ user.name }}</p>
                <p class="user-email">{{ user.email | maskEmail }}</p>
                <p class="user-id"><small>via {{ user.sub | titlecase}}</small></p>
              </div>
            </div>
            <div class="user-actions">
              @if (isRequestSent(user.userId || user._id || user.sub)) {
              <button class="connect-button sent" disabled>
                <i class="fas fa-check button-icon"></i>
                <span>Request Sent</span>
              </button>
              <button class="cancel-request-button" (click)="cancelConnectionRequestByUserId(user.userId || user._id || user.sub)" title="Cancel request">
                <i class="fas fa-times button-icon"></i>
                <span>Cancel</span>
              </button>
              } @else {
              <button type="button" class="connect-button" (click)="sendConnectionRequest(user)">
                <i class="fas fa-plus button-icon"></i>
                <span>Connect</span>
              </button>
              }
            </div>
          </div>
          }
        </div>
        } @else if (searchQuery.trim().length >= 2 && !isSearching) {
        <div class="no-results">
          <i class="fas fa-search"></i>
          <p>No users found</p>
          <p class="no-results-hint">Try searching with a different name or email</p>
        </div>
        } @else if (searchQuery.trim().length > 0 && searchQuery.trim().length < 2) { <div class="search-hint">
          <p>Type at least 2 characters to search</p>
      </div>
      }
    </div>
  </div>
</div>
}

<!-- Create Group Chat Modal -->
@if (showCreateGroupModal) {
<div class="create-group-overlay" (click)="toggleCreateGroupModal()">
  <div class="create-group-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Create Group Chat</h3>
      <button class="close-button" (click)="toggleCreateGroupModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label for="groupName">Group Name</label>
        <input type="text" id="groupName" class="form-input" [(ngModel)]="newGroupName" placeholder="Enter group name..." maxlength="50" />
      </div>

      <div class="form-group">
        <label>Select Participants</label>
        <div class="participants-list">
          @if (nonGroupContacts.length > 0) {
          @for (contact of nonGroupContacts; track contact.userId) {
          <div class="participant-item" (click)="toggleParticipantSelection(contact.userId)" [class.selected]="isParticipantSelected(contact.userId)">
            <div class="participant-avatar">
              @if (contact.avatar) {
              <img [src]="contact.avatar" [alt]="(contact.name || 'Contact') + ' avatar'" [title]="contact.name || 'Contact'" loading="lazy" />
              } @else {
              <div class="avatar-placeholder">
                <span>{{ contact.name.charAt(0).toUpperCase() }}</span>
              </div>
              }
            </div>
            <div class="participant-info">
              <span class="participant-name">{{ contact.name }}</span>
              <span class="participant-email">{{ contact.email }}</span>
            </div>
            <div class="participant-checkbox">
              @if (isParticipantSelected(contact.userId)) {
              <i class="fas fa-check"></i>
              }
            </div>
          </div>
          }
          } @else {
          <div class="empty-participants">
            <p>No contacts available</p>
            <p class="hint">Add contacts first to create a group chat</p>
          </div>
          }
        </div>
      </div>

      <div class="selected-count">
        @if (selectedParticipantsForGroup.length > 0) {
        <span>{{ selectedParticipantsForGroup.length }} participant(s) selected</span>
        } @else {
        <span class="hint">Select at least one participant</span>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" (click)="toggleCreateGroupModal()">Cancel</button>
      <button class="create-button" (click)="createGroupChat()" [disabled]="!newGroupName.trim() || selectedParticipantsForGroup.length === 0">
        Create Group
      </button>
    </div>
  </div>
</div>
}

<!-- Edit Group Chat Modal -->
@if (showEditGroupModal) {
<div class="create-group-overlay" (click)="toggleEditGroupModal()">
  <div class="create-group-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Edit Group Chat</h3>
      <button class="close-button" (click)="toggleEditGroupModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label for="editGroupName">Group Name</label>
        <input type="text" id="editGroupName" class="form-input" [(ngModel)]="editGroupName" placeholder="Enter group name..." maxlength="50" />
      </div>

      <div class="form-group">
        <label>Select Participants</label>
        <div class="participants-list">
          @if (nonGroupContacts.length > 0) {
          @for (contact of nonGroupContacts; track contact.userId) {
          <div class="participant-item" (click)="toggleEditParticipantSelection(contact.userId)" [class.selected]="isEditParticipantSelected(contact.userId)">
            <div class="participant-avatar">
              @if (contact.avatar) {
              <img [src]="contact.avatar" [alt]="(contact.name || 'Contact') + ' avatar'" [title]="contact.name || 'Contact'" loading="lazy" />
              } @else {
              <div class="avatar-placeholder">
                <span>{{ contact.name.charAt(0).toUpperCase() }}</span>
              </div>
              }
            </div>
            <div class="participant-info">
              <span class="participant-name">{{ contact.name }}</span>
              <span class="participant-email">{{ contact.email }}</span>
            </div>
            <div class="participant-checkbox">
              @if (isEditParticipantSelected(contact.userId)) {
              <i class="fas fa-check"></i>
              }
            </div>
          </div>
          }
          } @else {
          <div class="empty-participants">
            <p>No contacts available</p>
            <p class="hint">Add contacts first to add to group chat</p>
          </div>
          }
        </div>
      </div>

      <div class="selected-count">
        @if (selectedParticipantsForEdit.length > 0) {
        <span>{{ selectedParticipantsForEdit.length }} participant(s) selected</span>
        } @else {
        <span class="hint">Select at least one participant</span>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" (click)="toggleEditGroupModal()">Cancel</button>
      <button class="create-button" (click)="updateGroupChat()" [disabled]="!editGroupName.trim() || selectedParticipantsForEdit.length === 0">
        Update Group
      </button>
    </div>
  </div>
</div>
}

<!-- Create Poll Modal -->
@if (showCreatePollModal) {
<div class="create-poll-overlay" (click)="toggleCreatePollModal()">
  <div class="create-poll-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Create Poll</h3>
      <button class="close-button" (click)="toggleCreatePollModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label for="pollQuestion">Poll Question</label>
        <input type="text" id="pollQuestion" class="form-input" [(ngModel)]="newPollQuestion" placeholder="Ask a question..." maxlength="200" />
      </div>

      <div class="form-group">
        <label>Poll Options</label>
        <div class="poll-options-list">
          @for (option of newPollOptions; track $index) {
          <div class="poll-option-input-wrapper">
            <input type="text" class="poll-option-input" [(ngModel)]="newPollOptions[$index]" placeholder="Option {{ $index + 1 }}" maxlength="100" />
            @if (newPollOptions.length > 2) {
            <button class="remove-option-button" (click)="removePollOption($index)" title="Remove option">
              <i class="fas fa-times"></i>
            </button>
            }
          </div>
          }
        </div>
        @if (newPollOptions.length < 10) { <button class="add-option-button" (click)="addPollOption()">
          <i class="fas fa-plus"></i>
          <span>Add Option</span>
          </button>
          }
      </div>

      <div class="form-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="newPollAllowMultiple" />
          <span>&nbsp;Allow multiple votes</span>
        </label>
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" (click)="toggleCreatePollModal()">Cancel</button>
      <button class="create-button" (click)="createPoll()" [disabled]="!newPollQuestion.trim() || !hasValidPollOptions()">
        Create Poll
      </button>
    </div>
  </div>
</div>
}

<!-- Share Contact Modal -->
@if (showShareContactModal) {
<div class="share-contact-overlay" (click)="toggleShareContactModal()">
  <div class="share-contact-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Share Contact</h3>
      <button class="close-button" (click)="toggleShareContactModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label>Select a contact to share</label>
        <div class="contacts-list-share">
          @if (contacts.length > 0) {
          @for (contact of contacts; track contact.userId) {
          @if (contact.userId !== selectedContact?.userId) {
          <div class="contact-share-item" [class.selected]="selectedContactToShare?.userId === contact.userId" (click)="selectedContactToShare = contact">
            <div class="contact-avatar">
              @if (contact.avatar) {
              <img [src]="contact.avatar" [alt]="(contact.name || 'Contact') + ' avatar'" [title]="contact.name || 'Contact'" loading="lazy" />
              } @else {
              <div class="avatar-placeholder">
                <span>{{ contact.name.charAt(0).toUpperCase() }}</span>
              </div>
              }
            </div>
            <div class="contact-info">
              <p class="contact-name">{{ contact.name }}</p>
              <p class="contact-email">{{ contact.email }}</p>
            </div>
            @if (selectedContactToShare?.userId === contact.userId) {
            <div class="contact-selected-icon">
              <i class="fas fa-check"></i>
            </div>
            }
          </div>
          }
          }
          } @else {
          <div class="empty-state">
            <p>No contacts available to share</p>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" (click)="toggleShareContactModal()">Cancel</button>
      <button class="create-button" (click)="shareContact(selectedContactToShare!)" [disabled]="!selectedContactToShare">
        Share Contact
      </button>
    </div>
  </div>
</div>
}

<!-- Create Event Modal -->
@if (showCreateEventModal) {
<div class="create-event-overlay" (click)="toggleCreateEventModal()">
  <div class="create-event-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Create Event</h3>
      <button class="close-button" (click)="toggleCreateEventModal()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content">
      <div class="form-group">
        <label for="eventTitle">Event Title *</label>
        <input type="text" id="eventTitle" class="form-input" [(ngModel)]="eventForm.title" placeholder="Enter event title" maxlength="200" />
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="eventStartDate">Start Date *</label>
          <input type="date" id="eventStartDate" class="form-input" [(ngModel)]="eventForm.startDate" />
        </div>
        @if (!eventForm.allDay) {
        <div class="form-group">
          <label for="eventStartTime">Start Time</label>
          <input type="time" id="eventStartTime" class="form-input" [(ngModel)]="eventForm.startTime" />
        </div>
        }
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="eventEndDate">End Date *</label>
          <input type="date" id="eventEndDate" class="form-input" [(ngModel)]="eventForm.endDate" />
        </div>
        @if (!eventForm.allDay) {
        <div class="form-group">
          <label for="eventEndTime">End Time</label>
          <input type="time" id="eventEndTime" class="form-input" [(ngModel)]="eventForm.endTime" />
        </div>
        }
      </div>

      <div class="form-group">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="eventForm.allDay" />
          <span>&nbsp;All day event</span>
        </label>
      </div>

      <div class="form-group">
        <label for="eventCategory">Category</label>
        <select id="eventCategory" class="form-input" [(ngModel)]="eventForm.category">
          @for (category of eventCategories; track category.id) {
          <option [value]="category.id">{{ category.name }}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="eventDescription">Description</label>
        <textarea id="eventDescription" class="form-input" [(ngModel)]="eventForm.description" placeholder="Add event description..." rows="3" maxlength="500"></textarea>
      </div>

      <div class="form-group">
        <label for="eventLocation">Location</label>
        <input type="text" id="eventLocation" class="form-input" [(ngModel)]="eventForm.location" placeholder="Add location..." maxlength="200" />
      </div>

      <div class="form-group">
        <label for="eventReminder">Reminder</label>
        <select id="eventReminder" class="form-input" [(ngModel)]="eventForm.reminder">
          <option [value]="0">At time of event</option>
          <option [value]="5">5 minutes before</option>
          <option [value]="15">15 minutes before</option>
          <option [value]="30">30 minutes before</option>
          <option [value]="60">1 hour before</option>
          <option [value]="120">2 hours before</option>
          <option [value]="1440">1 day before</option>
          <option [value]="10080">1 week before</option>
        </select>
      </div>
    </div>

    <div class="modal-footer">
      <button class="cancel-button" (click)="toggleCreateEventModal()">Cancel</button>
      <button class="create-button" (click)="createEvent()" [disabled]="!eventForm.title.trim() || !eventForm.startDate || !eventForm.endDate">
        Create Event
      </button>
    </div>
  </div>
</div>
}
</div>
